import { type Ref, watch } from 'vue';
import type { SessionPassTheme } from './style-profile';

export function useSessionPassFonts(theme: Ref<SessionPassTheme | null>): void {
  watch(
    theme,
    (current, _previous, onCleanup) => {
      if (typeof FontFace === 'undefined' || !document.fonts) {
        return;
      }
      const faces = (current?.fontFaces ?? []).map(
        (face) =>
          new FontFace(face.family, `url("${face.url}")`, {
            style: face.style,
            weight: face.weight,
            display: 'swap',
          })
      );
      onCleanup(() => {
        for (const face of faces) {
          document.fonts.delete(face);
        }
      });
      for (const face of faces) {
        document.fonts.add(face);
      }
    },
    { immediate: true }
  );
}
